import { render } from "./Employee_Details.vue?vue&type=template&id=75bd02e8"
import script from "./Employee_Details.vue?vue&type=script&lang=js"
export * from "./Employee_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__